module.exports = __webpack_public_path__ + "static/media/tf.3cdeba0c.svg";